/* @flow */
export default class Star {
  type: number
  index: number
  name: string

  constructor(starType: number, index: number, name: string) {
    this.type = starType
    this.index = index
    this.name = name
  }
}
